// = Libs =
import { FC, useState } from 'react';
import clsx from 'clsx';
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, convertFromHTML, convertToRaw, EditorState } from 'draft-js';
// = Styles =
import classes from './rich-text.module.scss';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

// = Types =
import { InputProps } from '@/common/components/ui/input/input.types';
import draftToHtml from 'draftjs-to-html';

// = Components =

const RichText: FC<InputProps> = (props) => {
  const { value = '', className = '', onChange } = props;

  const [editorState, setEditorState] = useState<EditorState>(() => {
    const { contentBlocks, entityMap } = convertFromHTML(value);
    return EditorState.createWithContent(
      ContentState.createFromBlockArray(contentBlocks, entityMap)
    );
  });

  const handleChange = (editorState: EditorState): void => {
    setEditorState(editorState);
    // TODO: Перформанс вышел из чата
    onChange &&
      onChange(draftToHtml(convertToRaw(editorState.getCurrentContent())));
  };

  return (
    <div className={clsx({ [classes['rich-text']]: true }, className)}>
      <Editor
        editorState={editorState}
        onEditorStateChange={handleChange}
        editorClassName={classes['rich-text--text']}
      />
    </div>
  );
};

export default RichText;
